export const i18nTranslateOrFallback = (i18n, key, fallback) => {
  const translated = i18n.t(key);
  const isTranslated = translated && translated !== key;
  return isTranslated ? translated : fallback;
};
